import { EventInterceptionPlugin, FlagOverridePlugin } from '@launchdarkly/toolbar';

export const flagOverridePlugin = new FlagOverridePlugin({
  storageNamespace: 'ld-gonfalon-overrides',
});

export const eventInterceptionPlugin = new EventInterceptionPlugin({
  enableLogging: false,
});
